import React from "react";
import { Link, withRouter } from 'react-router';
import ProjectDetailTab from '../../projects/components/ProjectDetailTab';
import { Paper } from "@material-ui/core";
import { onCheckPermission } from "../../../utils_v2";
const TaskManagementWrapper = ({location, params, children, handleTabChange}) => {
    return (
        <div>
            <ProjectDetailTab tabIndex={'task-management'} handleTabChange={() => console.log('')} />
            <Paper className="tasks-management-section">
                <div className="sidebar-menu">
                    { onCheckPermission('task_management','stages','R') ?
                        <div className="menu-list">
                            <Link activeClassName="active" to={`/technical/project/${params.project_slug}/stages`}>Stages</Link>
                        </div>:null
                    }
                    { onCheckPermission('task_management','milestone','R') ?
                        <div className="menu-list">
                            <Link activeClassName="active" to={`/technical/project/${params.project_slug}/milestones`}>Milestones</Link>
                        </div>:null
                    }
                    { onCheckPermission('task_management','tasks','R') ?
                        <div className="menu-list">
                            <Link className={location.pathname.includes('task')?'active':''} to={`/technical/project/${params.project_slug}/tasks`}>Tasks</Link>
                        </div>:null
                    }
                    {onCheckPermission('task_management','issues','R') ?
                        <div className="menu-list">
                            <Link className={location.pathname.includes('issue')?'active':''} to={`/technical/project/${params.project_slug}/issues`}>Issues</Link>
                        </div>:null
                    }
                </div>
                <div className="tasks-management-content" style={{minHeight: window.innerHeight-110}}>
                    <div style={{padding:'15px'}}>
                        {children}
                    </div>
                </div>
            </Paper>
        </div>
    );
}
export default withRouter(TaskManagementWrapper);